import { canCancelSession, canRescheduleSession } from './sessionData';

import type { AppointmentActionRecord } from '@/features/appointments/appointmentActionRecord';
import type { CalendarActionSubject } from '@/features/appointments/calendarAppointmentProjection';

import {
  actionRecordCanCancel,
  actionRecordCanReschedule,
  isNativeAppointmentActionRecord,
} from '@/features/appointments/appointmentActionRecord';

// MEN-4122: one reschedule/cancel affordance gate for every coach Schedule
// surface. The List menu and the Week/Month info popover each had their own
// copy, and they disagreed: List asked the record
// (`actionRecordCanReschedule`, which requires `lifecycleStatus ===
// 'scheduled'`), the popover asked the projected Session
// (`canRescheduleSession`, which reads only `actionCapabilities`). Week and
// Month therefore offered reschedule and cancel on an Appointment in
// `cancellation_pending` or `reschedule_pending` — a second command against a
// mutation already in flight — that List correctly hid.
//
// The record is the authority for a native Appointment and the Session is the
// authority for a legacy Rails row, so the branch stays; what must not
// reappear is a second copy of it.

export const subjectActionRecord = (
  subject: CalendarActionSubject,
): AppointmentActionRecord =>
  subject.source === 'session' ? subject.session : subject;

export const recordCanReschedule = (
  record: AppointmentActionRecord,
  adminMode: boolean,
): boolean =>
  isNativeAppointmentActionRecord(record)
    ? actionRecordCanReschedule(record)
    : canRescheduleSession(record, adminMode);

export const recordCanCancel = (
  record: AppointmentActionRecord,
  adminMode: boolean,
): boolean =>
  isNativeAppointmentActionRecord(record)
    ? actionRecordCanCancel(record)
    : canCancelSession(record, adminMode);
